import { ClientModel } from 'model/client/client.model';
import { ConvertBritePaginationRequest } from 'model/client/client.request';
import { ApiConfig } from 'config/api.config';
import { convertBriteClient } from 'utils/convertBriteClient';

/**
 * Fetches client list from the API
 * @param params Request parameters for pagination
 * @returns Promise with client data
 */
export const getClients = async (params: ConvertBritePaginationRequest = { page_no: 1, per_page: 500 }): Promise<ClientModel[]> => {
  try {
    // Use the ConvertBriteClient to make the API request
    const data = await convertBriteClient.post<ClientModel[]>(ApiConfig.CLIENTS, params);
    
    // Return the clients array from the response
    return data || [];
  } catch (error) {
    console.error('Error fetching clients:', error);
    return [];
  }
};
